import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const HAND_RX = {
  right: /\br\w*\s*[:=]?\s*(\d+(?:\.\d+)?)/i,
  left: /\bl\w*\s*[:=]?\s*(\d+(?:\.\d+)?)/i,
};

// "R 32.5 / L 30" → { right: 32.5, left: 30 }
export function parseGripText(text) {
  const out = { right: null, left: null };
  for (const [hand, rx] of Object.entries(HAND_RX)) {
    const m = String(text || "").match(rx);
    if (m) out[hand] = parseFloat(m[1]);
  }
  return out;
}

// Debounced fetch of the age/sex norm comparison for the given grip values.
export function useGripNorms(assessmentId, left, right) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!assessmentId || (left == null && right == null)) { setData(null); return; }
    let live = true;
    const t = setTimeout(() => {
      const params = {};
      if (left != null) params.left = left;
      if (right != null) params.right = right;
      api.get(`/assessments/${assessmentId}/grip-norms`, { params })
        .then((r) => { if (live) setData(r.data); })
        .catch(() => { if (live) setData(null); });
    }, 400);
    return () => { live = false; clearTimeout(t); };
  }, [assessmentId, left, right]);
  return data;
}
